import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { FaTachometerAlt } from 'react-icons/fa';

// AdminRoute (in App.js) gates entry on the auth custom claim
// `claims.admin === true`. Sub-route navigation has been trimmed
// to just the dashboard until Customer/Billing/Revenue/Settings
// are real (audit F-013) — see AdminDashboardPage for context.
const AdminLayout = () => (
    <div className="flex h-screen bg-gray-100">
        {/* Sidebar */}
        <div className="w-64 bg-navy text-white flex flex-col">
            <div className="px-8 py-6">
                <h1 className="text-2xl font-bold text-amber">PettAI Admin</h1>
            </div>
            <nav className="flex-grow">
                <Link to="/admin" className="flex items-center gap-3 px-8 py-3 text-lg hover:bg-gray-700">
                    <FaTachometerAlt />
                    <span>Dashboard</span>
                </Link>
            </nav>
        </div>

        {/* Main Content */}
        <div className="flex-1 flex flex-col overflow-hidden">
            <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 p-8">
                <Outlet /> {/* Child routes will be rendered here */}
            </main>
        </div>
    </div>
);

export default AdminLayout;
